"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _CardContentModule = _interopRequireDefault(require("../../styles/components/CardContent.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Title = _ref => {
  let {
    title = '',
    id = null,
    style,
    className,
    lines = 1
  } = _ref;
  const [showTitle, setShowTitle] = (0, _react.useState)(false);
  const checkHidden = (0, _react.useCallback)(function () {
    let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const curOverf = el === null || el === void 0 ? void 0 : el.style.overflow;
    if (!curOverf || curOverf === 'visible') el.style.overflow = 'hidden';
    const isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
    el.style.overflow = curOverf;
    return isOverflowing;
  }, []);
  (0, _react.useEffect)(() => {
    const elementTitle = document.querySelector("#title_".concat(id));
    if (elementTitle) setShowTitle(checkHidden(elementTitle));
  }, [id, checkHidden]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CardContentModule.default.name_wrap, " ").concat(className),
    style: style
  }, showTitle ? /*#__PURE__*/_react.default.createElement(_paulCorePackage.TooltipWrap, {
    text: title
  }, /*#__PURE__*/_react.default.createElement("p", {
    id: "title_".concat(id),
    className: _CardContentModule.default.name,
    style: {
      WebkitLineClamp: lines
    }
  }, title)) : /*#__PURE__*/_react.default.createElement("p", {
    id: "title_".concat(id),
    className: _CardContentModule.default.name
  }, title)), [className, style, showTitle, title, id, lines]);
};
exports.Title = Title;